import { render } from "./PatientSearch.vue?vue&type=template&id=3e738c62&scoped=true&ts=true"
import script from "./PatientSearch.vue?vue&type=script&lang=ts"
export * from "./PatientSearch.vue?vue&type=script&lang=ts"

import "./PatientSearch.vue?vue&type=style&index=0&id=3e738c62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e738c62"]])

export default __exports__